import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=056bc5bc&scoped=true&"
import script from "./BaseFooter.vue?vue&type=script&lang=js&"
export * from "./BaseFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooter.vue?vue&type=style&index=0&id=056bc5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056bc5bc",
  null
  
)

export default component.exports